import { ReactElement } from 'react'

import { useOrganizationSource } from '../../../../hooks/useOrganizationSource'
import { ExternalInvoiceSettings } from './elements/ExternalInvoiceSettings'
import { InvoiceSettings } from './elements/InvoiceSettings'

export const OrganizationInvoiceSettings = (): ReactElement | null => {
  const { isSourceBilly, isSourceZervant } = useOrganizationSource()

  if (isSourceBilly) {
    return <InvoiceSettings />
  }

  if (isSourceZervant) {
    return <ExternalInvoiceSettings />
  }

  return null
}
